import { z } from 'zod';
import { errorEmail, errorPassword } from '../errorMessages';

export const emailSchema = z
  .string({ error: errorEmail.required })
  .min(1, { message: errorEmail.required })
  .max(254, { message: errorEmail.tooLong })
  .email({ message: errorEmail.invalidate });

export const passwordSchema = z
  .string({ error: errorPassword.required })
  .min(6, { message: errorPassword.size })
  .max(128, { message: errorPassword.tooLong });
// .max(20, { message: errorPassword.size })
// .refine((value) => /[A-Z]/.test(value), { message: errorPassword.uppercase })
// .refine((value) => /[a-z]/.test(value), { message: errorPassword.lowercase })
// .refine((value) => /[0-9]/.test(value), { message: errorPassword.number })
// .refine((value) => /[!@#$%^&()_+~{}:"<>?[\]',./]/.test(value), { message: errorPassword.special });
